<div class="analysis-footer-bar" data-cy="analysis-footer-bar">
  <p class="analysis-footer-bar__summary">
    <strong>{{ metrics.pending }}</strong> pendentes ·
    <strong>{{ metrics.approved }}</strong> aprovados ·
    <strong>{{ metrics.rejected }}</strong> rejeitados
  </p>

  <p class="analysis-footer-bar__hint">{{ pendingHint }}</p>

  <div class="analysis-footer-bar__actions">
    <app-button
      data-cy="approve-all-btn"
      [label]="approveAllLabel"
      [type]="'button'"
      [theme]="'default'"
      [disabled]="!canApproveAll"
      [isLoading]="isApprovingAll"
      [loadingText]="'Aprovando...'"
      (sendButtonClick)="approveAll.emit()">
    </app-button>

    <app-button
      data-cy="finalize-analysis-btn"
      [label]="finalizeLabel"
      [type]="'button'"
      [theme]="'highlight'"
      (sendButtonClick)="finalize.emit()">
    </app-button>
  </div>
</div>
